import { ILLoader } from "../../components";
import { useEmptyPage } from "../../hooks/auth/emptyPage.hook";

const ILEmptyPage = () => {
  const { isLoading } = useEmptyPage();

  return <>{isLoading && <ILLoader classname="loader-wrap-fixed" />}</>;
};
export default ILEmptyPage;
